<template>
  <ol class="breadcrumb">
    <li v-for="(j, i) in getEntry"
        class="breadcrumb-item"
        :title="getSubject(j)">
      <span v-if="i === getEntry.length - 1 && i > 0"
            v-safe-html="getSubject(j)" />
      <router-link
          v-else-if=" j.value !== null "
          :to="Object.assign({
              'name': j.value
          }, getQuery(j))"
          v-safe-html="getSubject(j)" />
      <a v-else
         v-safe-html="getSubject(j)" />
    </li>
  </ol>
</template>

<script setup>

import {sprintf} from "sprintf-js"

import {computed} from "vue"

import {useRoute} from "vue-router"

import {useI18n} from "vue-i18n"
import {useMenu} from "@/hook/useMenu"
import {EnumPortalDashboard, EnumPortalRouter} from "@/enum/portal"

;

const route = useRoute()

const {
  t
} = useI18n()

const {
  getCaption
} = useMenu()

const getEntry = computed(() =>{
  const d = route.meta.portal
  const breadcrumb = route.meta.breadcrumb
  return [{
    key: `${ d }.home.index`,
    value: EnumPortalDashboard[d] ?? EnumPortalRouter.ADMIN
  }].concat(breadcrumb)
})

/**
 * 轉換GET參數
 */
const getQuery = computed(() => {
  return (e) => {

    if ((route.name).startsWith("ShepherdTeam") && (e.value).startsWith("ShepherdTeam")) {

      const r = {}

      if (route.query.c) r.c = route.query.c
      if (route.query.p) r.q = route.query.p

      return {
        query: r
      }

    }

    return {}

  }
})

const getSubject = computed(() => {
  return (e) => {
    //MY
    if (e.key === 'admin.my.index') return sprintf(
        `%s%s`,
        getCaption.value.my,
        t(`component.breadcrumb.index.index`)
    )
    else if (e.key === 'admin.my.create') return t(`component.breadcrumb.index.create`)
    else if (e.key === 'admin.my.edit') return t(`component.breadcrumb.index.edit`)
    //SOUL
    else if (['admin.soul.subject', 'admin.soul.index'].includes(e.key)) return sprintf(
        `%s%s`,
        getCaption.value.soul,
        t(`component.breadcrumb.index.index`)
    )
    else if (e.key === 'admin.soul.create') return t(`component.breadcrumb.index.create`)
    else if (e.key === 'admin.soul.edit') return t(`component.breadcrumb.index.edit`)
    //SOUL-CATEGORY
    else if (e.key === 'admin.soul.category.index') return sprintf(
        `%s%s`,
        getCaption.value.soul,
        t(`component.breadcrumb.category.index`)
    )
    else if (e.key === 'admin.soul.category.create') return t(`component.breadcrumb.category.create`)
    else if (e.key === 'admin.soul.category.edit') return t(`component.breadcrumb.category.edit`)
    //DAILY
    else if (e.key === 'admin.daily.index') return sprintf(
        `%s%s`,
        getCaption.value.daily,
        t(`component.breadcrumb.index.index`)
    )
    else if (e.key === 'admin.daily.create') return t(`component.breadcrumb.index.create`)
    else if (e.key === 'admin.daily.edit') return t(`component.breadcrumb.index.edit`)
    return t(`nav.${e.key}`)
  }
})

</script>

<style scoped lang="scss">

@import '@/style/variables.scss';

.breadcrumb {
  font-size: 1.1rem;
  // 字體一致: navbar 容器覆寫成 ...Arial, sans-serif, 中文會 fallback 成與全站
  // (body 用 ...Arial, serif) 不同的 CJK 字型; 明確沿用 body 字體保持一致
  font-family: var(--bs-body-font-family);
  // 置入 navbar - 緊接系統切換器右側
  margin-left: 1.25rem;
  padding-top: 0;
  padding-bottom: 0;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  // 作為 bookmark-wrapper 的 flex item 允許收縮
  min-width: 0;
  // 極端過窄（所有節點皆觸底）時裁切不破版的最後防線
  overflow: hidden;
  > li {
    font-weight: 400;
    &.breadcrumb-item {
      // 改 flex：::before 分隔符成獨立 flex item，文字才能單獨 ellipsis
      display: flex;
      align-items: center;
      min-width: 0;
      &::before {
        position: relative;
        top: .1rem;
        // chevron 分隔符不縮
        flex-shrink: 0;
      }
      > a, > span {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      // 中間節點：優先吸收縮壓，縮到下限即停（約 2~3 個中文字 + …）
      &:not(:first-child):not(:last-child) {
        flex-shrink: 100;
        min-width: 4.5em;
      }
      // 最後節點（目前頁）：最後才縮，保留較高可讀下限
      &:last-child {
        flex-shrink: 1;
        min-width: 6em;
      }
      // 首節點（控制面板，字短固定）不縮；刻意宣告在 :last-child 之後，
      // 單節點（同時為 first/last）時同特異性後者勝出 → 不縮
      &:first-child {
        flex-shrink: 0;
        min-width: auto;
      }
    }
    > a {
      color: map-get($theme-color, "primary") !important;
      font-weight: 500;


    }
  }
}
</style>
